// extracted by mini-css-extract-plugin
export default {"microfrontend":"microfrontend_microfrontend__quhht"};